/**
 * Main entry file
 *
 * @author Lemuel Raganas
 */

declare global {
  interface Window {
    WorldCup: any;
    Popper: any;
    $: any;
    jQuery: any;
  }
}

/***********************
 * STYLES
 **********************/
import "./assets/bootstrap-custom/cna-compatible.css";
import "lato-font/css/lato-font.css";
import "noty/lib/noty.css";
import "noty/lib/themes/sunset.css";

/***********************
 * SCRIPTS
 **********************/
import jQuery from "jquery";
const $ = jQuery;
window.$ = window.jQuery = jQuery;

import Popper from "popper.js";
window.Popper = Popper;

import "bootstrap";
import Isotope from "isotope-layout";
import "noty";

import WorldCup from "./libs/WorldCup";

window.WorldCup = WorldCup;
